<template>
  <div>
    <div class="dialog-button">
      <div v-if="isSuper == 0">
        <label>可见时间：</label>
        <el-select v-model="sysTime" value-key="value" placeholder="请选择"  style="width: 6em;">
          <el-option v-for="item in sysTimeList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div>
        <label>编辑日志：</label>
        <el-switch
            v-model="operateLog"
            size="large"
            inline-prompt
            active-text="是"
            inactive-text="否"
            :active-value="2"
            :inactive-value="0"
        />
      </div>
<!--      <div>-->
<!--        <label>积分/金币：</label>-->
<!--        <el-select v-model="operateGold" value-key="value" placeholder="请选择"  style="width: 7.4em;">-->
<!--          <el-option v-for="item in operateGoldList" :key="item.value" :label="item.label" :value="item.value">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </div>-->
<!--      <div>-->
<!--        <label>信息审核：</label>-->
<!--        <el-select v-model="operateResume" value-key="value" placeholder="请选择"  style="width: 7.4em;">-->
<!--          <el-option v-for="item in operateResumeList" :key="item.value" :label="item.label" :value="item.value">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </div>-->
      <div>
        <el-button type="primary" @click="submit()">提交</el-button>
      </div>
    </div>
    <div class="dialog-main">
      <div class="dialog-main-tiem">
        <div class="item-title">
          <p>管理目录</p>
          <div>
            <el-button type="text" @click="allChecked">全选</el-button>
            <el-button type="text" @click="notChecked">全不选</el-button>
          </div>
        </div>
        <el-scrollbar max-height="500px">
          <el-tree :data="dataArray" show-checkbox node-key="id" ref="tree" :default-checked-keys="defaultChecked" :props="defaultProps" style="line-height: 26px;"></el-tree>
        </el-scrollbar>
      </div>
<!--      <div class="dialog-main-tiem item-last">-->
<!--        <div class="item-title">-->
<!--          <p>对应渠道</p>-->
<!--          <div>-->
<!--            <el-button type="text" @click="allChannelChecked">全选</el-button>-->
<!--            <el-button type="text" @click="notChannelChecked">全不选</el-button>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="item-title-tips">注：“全不选”代表无渠道限制，可看到所有数据</div>-->
<!--        <el-scrollbar max-height="500px">-->
<!--          <el-tree :data="channelArray" show-checkbox node-key="id" ref="channelTree" :default-checked-keys="defaultChannelChecked" :props="defaultChannelProps" style="line-height: 26px;"></el-tree>-->
<!--        </el-scrollbar>-->
<!--      </div>-->
    </div>
  </div>

</template>

<script>
import {postJson, postFormData, getFormData} from "@/api/api"
import { menuListAll, updateSysModel, getAllChannelPackageList } from "@/api/url";

export default {
name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
   return {
     userModelForm: this.value.userModelForm,
     powerList: this.value.powerList,

     //管理目录
     dataArray: [],
     defaultProps: {
       children: 'children',
       label: 'name'
     },
     defaultChecked:[],

     //渠道包名
     channelArray: [],
     defaultChannelProps: {
       children: 'channelList',
       label: 'name'
     },
     defaultChannelChecked:[],

     operateState: this.value.userModelForm.operateState,

     operateLog: this.value.userModelForm.operateState & 2,

     //
     // operateGoldList: [
     //   {label: '不可操作', value: 0},
     //   {label: '可操作', value: 2},
     // ],
     // operateGold: this.value.userModelForm.operateState == 0?0:this.value.userModelForm.operateState == 2?2:this.value.userModelForm.operateState == 4?0:this.value.userModelForm.operateState == 6?2:0,
     //
     // operateResumeList: [
     //   {label: '不可操作', value: 0},
     //   {label: '可操作', value: 4},
     // ],
     // operateResume: this.value.userModelForm.operateState == 0?0:this.value.userModelForm.operateState == 2?0:this.value.userModelForm.operateState == 4?4:this.value.userModelForm.operateState == 6?4:0,

     sysTimeList: [
       {label: '不限', value: 0},
       {label: '1个月', value: 1},
       {label: '2个月', value: 2},
       {label: '3个月', value: 3},
       {label: '6个月', value: 6},
       {label: '1年', value: 12},
       {label: '2年', value: 24},
     ],
     sysTime: 0,
     isSuper: 0
   }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    notChecked() {
      this.$refs.tree.setCheckedKeys([]);
    },
    allChecked() {
      this.$refs.tree.setCheckedNodes(this.powerList);
    },

    notChannelChecked() {
      this.$refs.channelTree.setCheckedKeys([]);
    },
    allChannelChecked() {
      this.$refs.channelTree.setCheckedNodes(this.channelArray);
    },

    submit() {
      let _this = this;
      let checkIds = this.getChecked();
      // let channelCheckIds = this.getChannelChecked()
      let param = {}
      param['id'] = this.userModelForm.id;
      param['sysModelIds'] = checkIds.toString();
      // param['channelIds'] = channelCheckIds.toString();
      param['duration'] = this.sysTime;
      param['operateState'] = this.operateLog;
      postFormData(updateSysModel, param).then((data) => {
        let { code, msg } = data;
        if (code == 200) {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          _this.$emit('confirm')
        } else {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: '获取失败',
            type: 'warning'
          })
        }
      })
    },

    //获取管理员权限
    // getMenuListFrom(account) {
    //   let _this = this;
    //   getFormData(menuListAll, {}).then((data) => {
    //     let code = data.code;
    //     if(code == 200) {
    //       _this.isSuper = account.isSuper;
    //       _this.sysTime = account.duration;
    //       _this.powerList = data.data;
    //       _this.dataArray = this.formatList(this.powerList, 0);
    //       // console.log(_this.dataArray)
    //       let ids = [];
    //       if(account.sysModelIds) {
    //         ids = account.sysModelIds.split(",");
    //       }
    //       _this.defaultChecked = _this.getDefaultChecked(ids, _this.dataArray);
    //       _this.account = account;
    //     } else {
    //       _this.$message({
    //         showClose: true,
    //         duration: 1000,
    //         message: '获取失败',
    //         type: 'warning'
    //       })
    //     }
    //   })
    // },

    getMenuList(account) {
      this.isSuper = account.isSuper;
      this.sysTime = account.duration;
      this.dataArray = this.formatList(this.powerList, 0);
      // console.log(_this.dataArray)
      let ids = [];
      if(account.sysModelIds) {
        ids = account.sysModelIds.split(",");
      }
      this.defaultChecked = this.getDefaultChecked(ids, this.dataArray);
      this.account = account;
    },

    formatList(list, preId) {
      let array = [];
      let _this = this;
      list.forEach(function(e) {
        if(e['preId'] == preId) {
          let children = _this.formatList(list, e['id']);
          if(children.length > 0) {
            e['children'] = children;
          }
          array.push(e);
        }
      });
      return array;
    },
    //获取默认选项
    getDefaultChecked(array, dataArray) {
      let ids = array;
      for(let i = array.length-1; i >= 0; i--) {
        dataArray.forEach((e) => {
          if(e.id == array[i] && e.children != null) {
            ids = this.getDefaultChecked(array, e.children);
            ids.splice(i, 1);
          }
        })
      }
      return ids;
    },
    //获取提交参数
    getChecked() {
      let idArray = [];
      let array = this.$refs.tree.getCheckedNodes();
      // console.log(array)
      array.forEach((e) => {
        idArray = idArray.concat(e.id);
        idArray = idArray.concat(this.getParentChecked(e))
      });
      return idArray;
    },
    //提交时获取父级的id
    getParentChecked(el) {
      let array = [];
      if(el.level > 2) {
        array = array.concat(el.preId);
        this.powerList.forEach((e) => {
          if(e.id == el.preId) {
            array = array.concat(this.getParentChecked(e));
          }
        })
      } else if(el.level == 2) {
        array = array.concat(el.preId);
      }
      return array;
    },


    //包名渠道列表
    // getChannelPackageList(account) {
    //   getFormData(getAllChannelPackageList).then((data) => {
    //     let {msg, code} = data;
    //     if (code == 200) {
    //       let dataList = data.data;
    //       // console.log(dataList)
    //       for (let i=0; i<dataList.length; i++) {
    //         dataList[i].name = dataList[i].packageName;
    //         for (let j=0; j<dataList[i].channelList.length; j++) {
    //           dataList[i].channelList[j].name = dataList[i].channelList[j].channel
    //         }
    //       }
    //       this.channelArray = dataList
    //       let ids = [];
    //       if(account.channelIds) {
    //         ids = account.channelIds.split(",");
    //       }
    //       this.defaultChannelChecked = ids
    //     }else {
    //       this.$message({
    //         showClose: true,
    //         duration: 1000,
    //         message: msg,
    //         type: 'warning'
    //       })
    //     }
    //   })
    // },

    getChannelChecked() {
      let idArray = [];
      let array = this.$refs.channelTree.getCheckedNodes();
      array.forEach((e) => {
        if (!e.channelList) {
          idArray.push(e.id)
        }
      })
      return idArray
    }

  },
  mounted() {
    this.getMenuList(this.userModelForm)
    // this.getChannelPackageList(this.userModelForm)
  }
}
</script>

<style scoped>
.dialog-button {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

.item-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.item-title-tips {
  font-size: 12px;
  color: #aaaaaa;
  margin-bottom: 12px;
}

.dialog-main {
  display: flex;
  justify-content: space-between;
}


.item-title p {
  font-weight: bold;
  color: #222222;
}

.dialog-main-tiem {
  border: #ededed 1px solid;
  padding: 16px 24px;
  width: 100%;
  margin-right: 16px;
}

.item-last {
  margin-right: 0;
}

</style>
